import {gql} from 'apollo-angular';

export const GET_SCHOOL_TEACHERS = gql`
  query GetSchoolTeachers {
    getSchoolTeachers {
      id,
      firstname,
      lastname,
      email
    }
  }
`;
